module.exports = __webpack_public_path__ + "img/ic_liveticker_card_red_yellow.bc915d59.svg";